<template #content>
    <Dialog :visible="visible" @update:visible="updateVisible" header="Estado" @show="onShow" @hide="onHide"
        class="w-11 lg:w-4" modal>
        <form @submit.prevent="onSubmit(form)">
            <div class="w-full">
                <div class="field mt-4">
                    <FloatLabel>
                        <InputText id="nome" v-model="form.nome" class="w-full" />
                        <label for="nome">Nome<span class="text-red-500">*</span></label>
                    </FloatLabel>
                    <div class="text-xs text-red-500">{{ errors['nome'] }}</div>
                </div>
                <div class="field mt-4">
                    <FloatLabel>
                        <InputText id="uf" v-model="form.uf" class="w-full" />
                        <label for="uf">UF<span class="text-red-500">*</span></label>
                    </FloatLabel>
                    <div class="text-xs text-red-500">{{ errors['uf'] }}</div>
                </div>
            </div>

            <div class="flex justify-content-end gap-1">
                <Button type="submit" label="Salvar" severity="success" icon="pi pi-save" size="small"
                    class="flex align-items-center justify-content-center" :loading="isLoading" />
                <Button label="Fechar" severity="warn" icon="pi pi-times" size="small" @click="updateVisible(false)"
                    class="flex align-items-center justify-content-center" :loading="isLoading" />
            </div>
        </form>

    </Dialog>
</template>
<script>
import Dialog from 'primevue/dialog';
import FloatLabel from 'primevue/floatlabel';
import InputText from 'primevue/inputtext';
import Checkbox from 'primevue/checkbox';
import Button from 'primevue/button';

import Estado from '@/service/estado.js';

export default {
    components: {
        Dialog,
        FloatLabel,
        Button,
        InputText,
        Checkbox,
        Button
    },
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        data: {
            type: Object,
            default: {}
        },
    },
    emits: ['save', 'close'],
    data() {
        return {
            form: {},
            errors: {},
            isLoading: false,
        }
    },
    methods: {
        onShow() {
            this.errors = {};
            this.form = { ...this.data };
        },
        onHide() {
            this.form = {};
        },
        updateVisible(visible) {
            this.$emit('close', visible);
        },
        save(form) {
            if (form.id) {
                return Estado.update(form.id, form);
            }
            return Estado.create(form);
        },
        onSubmit(form) {
            this.errors = {};
            this.isLoading = true;
            this.save(form)
                .then(response => {
                    this.$toast.add({ severity: 'success', summary: 'Sucesso', detail: 'Seus dados foram salvos com sucesso.', life: 3000 });
                    this.$emit('save');
                    this.$emit('close');
                })
                .catch(error => {
                    if (error.response) {
                        let err = error.response.data;
                        if (err.erros) {
                            for (let i in err.erros) {
                                this.errors[i] = err.erros[i][0];
                            }
                            return;
                        }
                        if (error.response.data.msg) {
                            this.$toast.add({ severity: 'error', summary: 'Ops!', detail: error.response.data.msg, life: 5000 });
                            return;
                        }
                    }
                    this.$toast.add({ severity: 'error', summary: 'Ops!', detail: error.message, life: 5000 });
                })
                .finally(() => {
                    this.isLoading = false;
                });
        }
    }
}
</script>
